export const get = (key: string): string => {
  // @ts-ignore
  const mergedEnv = Object.assign({}, process.env, window.__env);
  return mergedEnv[key] || mergedEnv[`REACT_APP_${key}`];
};

type EnvironmentVariablesConfig = {
  FHIR_SERVER_URL: string;
  BASENAME: string;
};

const config: EnvironmentVariablesConfig = {
  FHIR_SERVER_URL: get("FHIR_SERVER_URL"),
  BASENAME: get("BASENAME"),
};

export default config;
